<template>
  <div class="container-edit">
    <Card shadow class="content">
      <div class="main">
        <div style="text-align: right">
          <i-switch v-model="cmdModal" size="large">
            <span slot="open">cmd</span>
            <span slot="close">cmd</span>
          </i-switch>
        </div>
        <div v-if="cmdModal">
          <Row style="padding-top: 5px">
            <Input type="textarea" :rows="4" v-model="cmd" placeholder="命令行：docker run ..."/>
          </Row>
          <Row style="padding-top: 5px">
            <div style="float: left">
              <Poptip
                v-if="cmd"
                confirm
                transfer
                title="生成后将覆盖当前命令行，请确认"
                @on-ok="ObjectToCmdSubmit"
                ok-text="确认"
                cancel-text="取消"
                placement="bottom">
                <Button type="primary" :loading="ObjectToCmdSubmitting" size="small">生成命令行</Button>
              </Poptip>
              <Button v-else type="primary" :loading="ObjectToCmdSubmitting" @click="ObjectToCmdSubmit" size="small">生成命令行</Button>
            </div>
            <div style="float: right">
              <Button type="primary" @click="CmdToObjectSubmit" :loading="cmdToObjectSubmitting" size="small">转换成表单</Button>
            </div>
          </Row>
          <Divider/>
        </div>
        <Form ref="addForm" :model="addForm" :rules="addFormRules" inline :label-width="50">
          <Row :gutter="48">
            <Col :md="24" :lg="12">
              <Row class="title">
                <h4 :style="{float: 'left'}">部署节点</h4>
              </Row>
              <Row>
                <FormItem label="节点" prop="node" style="width: 100%">
                  <Select v-model="addForm.node" @on-change="nodeChange" placeholder="请选择要部署的节点">
                    <Option v-for="item in nodes" :key="item.id" :value="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">容器配置</h4>
              </Row>
              <Row>
                <FormItem label="容器名" prop="name" style="width: 100%">
                  <Input v-model="addForm.name" placeholder="Container Name"/>
                </FormItem>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">镜像配置</h4>
              </Row>
              <Row>
                <Col :md="24" :lg="12" style="padding-right: 5px">
                  <FormItem label="镜像" prop="image" style="width: 100%">
                    <Input v-model="addForm.image" placeholder="Image"/>
                    <!--<Select v-model="addForm.image" placeholder="请选择要部署的镜像" clearable filterable ref="addFormImage" not-found-text="请先选择节点">-->
                      <!--<Option v-for="item in images" :key="item.Id" :value="item.RepoTags[0]" v-if="item.RepoTags.length">{{ item.RepoTags[0] }}</Option>-->
                    <!--</Select>-->
                  </FormItem>
                </Col>
                <Col :md="24" :lg="12" style="padding-right: 5px">
                  <FormItem label="命令" prop="command" style="width: 100%">
                    <Input v-model="addForm.command" placeholder="Command"/>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col :md="24" :lg="12" style="padding-right: 5px">
                  <FormItem label="主机名" prop="hostname" style="width: 100%">
                    <Input v-model="addForm.hostname" placeholder="Hostname"/>
                  </FormItem>
                </Col>
                <Col :md="24" :lg="12" style="padding-right: 5px">
                  <FormItem label="域" prop="domainname" style="width: 100%">
                    <Input v-model="addForm.domainname" placeholder="domain"/>
                  </FormItem>
                </Col>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">重启策略</h4>
              </Row>
              <Row>
                <Form ref="restartPolicyForm" :model="restartPolicyData" :rules="restartPolicyRules" inline>
                  <Col :lg="12" style="padding-right: 5px">
                    <FormItem label="重启策略" style="width: 100%" prop="restartPolicyName">
                      <Select v-model="restartPolicyData.restartPolicyName">
                        <Option v-for="item in restartPolicyList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col :lg="12" v-if="restartPolicyData.restartPolicyName === 'on-failure'" style="padding-right: 5px">
                    <FormItem label="失败时最大重启次数" style="width: 100%" prop="MaximumRetryCount">
                      <Input placeholder="失败时最大重启次数" v-model="restartPolicyData.MaximumRetryCount"/>
                    </FormItem>
                  </Col>
                </Form>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">网络模式</h4>
              </Row>
              <Row>
                <FormItem label="网络模式" style="width: 100%" prop="network_mode" :label-width="70">
                  <Select v-model="addForm.network_mode">
                    <Option v-for="item in networkModeList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Row>
            </Col>
            <Col :md="24" :lg="12">
              <Row class="title">
                <h4 :style="{float: 'left'}">高级</h4>
              </Row>
              <Row v-if="addForm.healthcheck">
                <FormItem label="健康检测" :label-width="65">
                  <Input v-model="addForm.healthcheck.test" placeholder="Health Check" style="width: 400px"/>
                </FormItem>
              </Row>
              <Row v-if="addForm.healthcheck">
                <FormItem label="健康检测重试次数" :label-width="115">
                  <Input v-model="addForm.healthcheck.retries " placeholder="Health Check Retries (Default 3)" style="width: 200px"/>
                </FormItem>
              </Row>
              <Row>
                <FormItem label="PID模式" :label-width="60">
                  <Input v-model="addForm.pid_mode" placeholder="PID mode" style="width: 200px"/>
                </FormItem>
              </Row>
              <Row>
                <FormItem label="入口点" :label-width="55">
                  <Input v-model="addForm.entrypoint" placeholder="Entrypoint" style="width: 200px"/>
                </FormItem>
              </Row>
              <Row>
                <FormItem label="分配伪终端 (tty)" :label-width="100">
                  <i-switch v-model="addForm.tty">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
              </Row>
              <Row>
                <FormItem label="允许容器在特权模式下运行" :label-width="160">
                  <i-switch v-model="addForm.privileged">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
              </Row>
              <Row>
                <FormItem label="内核权限" :label-width="65">
                  <i-switch v-model="kernelPermission">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
              </Row>
              <Row>
                <FormItem label="自动删除" :label-width="65">
                  <i-switch v-model="addForm.auto_remove">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">资源限制</h4>
              </Row>
              <Row>
                <Col :md="24" :lg="24" style="padding-right: 5px">
                  <FormItem label="Cpus限制" prop="nano_cpus" style="width: 100%" :label-width="70">
                    <InputNumber :min="1" v-model="addForm.nano_cpus" placeholder="" type="number"/>
                  </FormItem>
                </Col>
                <Col :md="24" :lg="24" style="padding-right: 5px">
                  <FormItem label="Mems限制（单位：MB）" prop="mem_limit" style="width: 100%" :label-width="150">
                    <InputNumber :min="1" v-model="addForm.mem_limit" placeholder="∞"/>
                  </FormItem>
                </Col>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">目录映射</h4>
                <Button icon="md-add" type="primary" size="small" style="margin: 6px 12px" @click="addVolumesItem"></Button>
              </Row>
              <Row>
                <div v-for="(volumes, index) in volumesData" :key="index">
                  <Form ref="volumesForm" :model="volumes" :rules="volumesRules" inline>
                    <Row>
                      <Col :lg="9">
                        <FormItem prop="hostPath" style="width: 100%" :label-width="5">
                          <Input v-model="volumes.hostPath" placeholder="主机路径" />
                        </FormItem>
                      </Col>
                      <Col :lg="6">
                        <FormItem prop="mode" style="width: 100%" :label-width="5" label="">
                          <Select v-model="volumes.mode" placeholder="模式（默认读写）" clearable>
                            <Option v-for="item in volumesModeList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                          </Select>
                        </FormItem>
                      </Col>
                      <Col :lg="9">
                        <FormItem prop="bind" style="width: 100%" :label-width="5" label="">
                          <Input v-model="volumes.bind" placeholder="容器路径">
                            <Button slot="append" icon="md-close" @click="removeVolumesItem(index)"></Button>
                          </Input>
                        </FormItem>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">环境变量</h4>
                <Button icon="md-add" type="primary" size="small" style="margin: 6px 12px" @click="addEnvItem"></Button>
              </Row>
              <Row>
                <div v-for="(env, index) in environmentData" :key="index">
                  <Form ref="envForm" :model="env" :rules="envRules" inline>
                    <FormItem prop="envName" style="width: 100%">
                      <Input v-model="env.envValue" placeholder="变量值" class="env-value text-dark-input">
                      <Input v-model="env.envName" placeholder="变量名" slot="prepend" style="width: 200px" size="small"/>
                      <Button slot="append" icon="md-close" @click="removeEnvItem(index)"></Button>
                      </Input>
                    </FormItem>
                  </Form>
                </div>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">容器链接</h4>
                <Button icon="md-add" type="primary" size="small" style="margin: 6px 12px" @click="addLinksItem"></Button>
              </Row>
              <Row>
                <div v-for="(link, index) in links" :key="index">
                  <Form ref="linkForm" :model="link" :rules="linkRules" inline>
                    <FormItem prop="container" style="width: 100%">
                      <Input v-model="link.alias" placeholder="别名（选填）" class="env-value">
                      <Select class="text-dark-select" v-model="link.container" placeholder="选择容器" slot="prepend" style="width: 200px" size="small" not-found-text="请先选择节点">
                        <Option v-for="linkContainer in containers" :key="linkContainer.Id" :value="linkContainer.Id">{{ linkContainer.Name }}</Option>
                      </Select>
                      <Button slot="append" icon="md-close" @click="removeLinksItem(index)"></Button>
                      </Input>
                    </FormItem>
                  </Form>
                </div>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">容器DNS</h4>
                <Button icon="md-add" type="primary" size="small" style="margin: 6px 12px" @click="addDnsItem"></Button>
              </Row>
              <Row>
                <div v-for="(dns, index) in dnsData" :key="index">
                  <Form ref="dnsForm" :model="dns" :rules="dnsRules" inline>
                    <FormItem prop="dnsName" style="width: 100%">
                      <Input v-model="dns.dnsName" :placeholder="`DNS${index + 1}`" class="env-value">
                        <Button slot="append" icon="md-close" @click="removeDnsItem(index)"></Button>
                      </Input>
                    </FormItem>
                  </Form>
                </div>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">端口映射</h4>
                <Button icon="md-add" type="primary" size="small" style="margin: 6px 12px" @click="addPortsItem"></Button>
              </Row>
              <Row>
                <div v-for="(port, index) in portsData" :key="index">
                  <Form ref="portsForm" :model="port" :rules="portsRules" inline>
                    <Row>
                      <Col :lg="6">
                        <FormItem prop="host_address" style="width: 100%" :label-width="5" label="">
                          <Input v-model="port.host_address" placeholder="主机监听地址" />
                        </FormItem>
                      </Col>
                      <Col :lg="6">
                        <FormItem prop="host_port" style="width: 100%" :label-width="5">
                          <Input v-model="port.host_port" placeholder="主机端口" />
                        </FormItem>
                      </Col>
                      <Col :lg="6">
                        <FormItem prop="protocol" style="width: 100%" :label-width="5" label="">
                          <Select v-model="port.protocol" placeholder="协议">
                            <Option v-for="item in protocolList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                          </Select>
                        </FormItem>
                      </Col>
                      <Col :lg="6">
                        <FormItem prop="container_port" style="width: 100%" :label-width="5" label="">
                          <Input v-model="port.container_port" placeholder="容器端口">
                            <Button slot="append" icon="md-close" @click="removePortsItem(index)"></Button>
                          </Input>
                        </FormItem>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Row>
            </Col>
          </Row>
        </Form>
        <div style="text-align: center; box-shadow: 0 4px 18px -4px rgba(0,0,0,.1); padding: 25px 0;">
          <Button type="primary" style="margin-right: 10px" :loading="submitting" @click="submit">部署</Button>
          <Button @click="$router.go(-1)">取消</Button>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getAllNodes } from '@/api/container/node'
// import { getAllImages } from '@/api/container/image'
import { getAllContainers, runContainer } from '@/api/container/container'
import { ContainerRunCmdToObject, ContainerRunObjectToCmd } from '@/api/container/cmd'

export default {
  name: 'edit',
  data () {
    return {
      nodes: [],
      // images: [],
      containers: [],
      addForm: {
        node: '',
        name: '',
        image: '',
        command: '',
        hostname: '',
        domainname: '',
        network_mode: 'bridge',
        privileged: false,
        tty: false,
        auto_remove: false,
        entrypoint: '',
        pid_mode: '',
        cap_add: [],
        nano_cpus: null,
        mem_limit: null,
        volumes: {},
        environment: [],
        links: {},
        dns: [],
        restart_policy: {
          Name: '',
          MaximumRetryCount: null
        },
        healthcheck: {
          test: '',
          retries: ''
        }
      },
      addFormRules: {
        node: { required: true, type: 'number', trigger: 'change', message: '请选择要部署的节点' },
        image: { required: true, trigger: 'change', message: '请选择要部署的镜像' },
        network_mode: { required: true, trigger: 'blur', message: '请选择网络模式' }
      },
      submitting: false,
      // 内核权限
      kernelPermission: false,
      // 挂载目录
      volumesModeList: [
        { value: 'rw', label: '读和写' },
        { value: 'ro', label: '只读' },
        { value: 'shared', label: '共享' }
      ],
      volumesData: [],
      volumesRules: {
        hostPath: { required: true, trigger: 'blur', message: '主机路径不能为空' },
        bind: { required: true, trigger: 'blur', message: '容器路径不能为空' }
        // mode: { required: true, trigger: 'change', message: '请选择映射模式' }
      },
      // 环境变量
      environmentData: [],
      envRules: {
        envName: { required: true, trigger: 'blur', message: '变量名不能为空' },
        envValue: { required: true, trigger: 'blur', message: '变量值不能为空' }
      },
      // 容器链接
      links: [],
      linkRules: {
        container: { required: true, trigger: 'change', message: '请选择容器' }
      },
      // DNS
      dnsData: [],
      dnsRules: {
        dnsName: { required: true, trigger: 'blur', message: 'dns不能为空' }
      },
      // 重启策略
      restartPolicyList: [
        { value: 'no', label: '不自动重启' },
        { value: 'on-failure', label: '失败时重启' },
        { value: 'always', label: '永远自动重启' }
      ],
      restartPolicyData: {
        restartPolicyName: 'no',
        MaximumRetryCount: null
      },
      restartPolicyRules: {
        restartPolicyName: { required: true, trigger: 'blur', message: '请选择重启策略' },
        MaximumRetryCount: { required: true, trigger: 'blur', message: '请填写失败时最大重启次数' }
      },
      // 网络模式
      networkModeList: [
        { value: 'bridge', label: '桥接模式' },
        { value: 'host', label: '主机模式' },
        { value: 'none', label: '缺省模式' }
      ],
      // 端口映射
      protocolList: [
        { value: 'tcp', label: 'TCP' },
        { value: 'udp', label: 'UDP' }
      ],
      portsData: [],
      portsRules: {
        container_port: { required: true, trigger: 'blur', message: '容器端口不能为空' },
        protocol: { required: true, trigger: 'change', message: '请选择协议' },
        host_address: { required: true, trigger: 'blur', message: '主机监听地址不能为空' },
        host_port: { required: true, trigger: 'blur', message: '主机断开不能为空' }
      },

      // 命令行
      cmdModal: false,
      cmdToObjectSubmitting: false,
      ObjectToCmdSubmitting: false,
      cmd: ''
    }
  },
  created: function () {
    this.getNodes()
  },
  methods: {
    getNodes () {
      getAllNodes().then(res => {
        this.nodes = res.data
      }).catch(res => {
        console.log(res.response)
      })
    },
    // getImages (node) {
    //   getAllImages(node).then(res => {
    //     this.images = res.data
    //   }).catch(res => {
    //     console.log(res.response)
    //   })
    // },
    getContainers (node) {
      getAllContainers(node).then(res => {
        this.containers = res.data
      }).catch(res => {
        console.log(res.response)
      })
    },
    nodeChange (node) {
      // this.$refs.addFormImage.clearSingleSelect()
      for (let i in this.$refs.addFormContainer) {
        this.$refs.addFormContainer[i].clearSingleSelect()
      }
      // this.images = []
      this.containers = []
      if (node) {
        // this.getImages(node)
        this.getContainers(node)
      }
    },
    addVolumesItem () {
      this.volumesData.push({
        hostPath: '',
        bind: '',
        mode: ''
      })
    },
    removeVolumesItem (index) {
      this.volumesData.splice(index, 1)
    },
    addEnvItem () {
      this.environmentData.push({
        envName: '',
        envValue: ''
      })
    },
    removeEnvItem (index) {
      this.environmentData.splice(index, 1)
    },
    addLinksItem () {
      this.links.push({
        container: '',
        alias: null
      })
    },
    removeLinksItem (index) {
      this.links.splice(index, 1)
    },
    addDnsItem () {
      this.dnsData.push({
        dnsName: ''
      })
    },
    removeDnsItem (index) {
      this.dnsData.splice(index, 1)
    },
    addPortsItem () {
      this.portsData.push({
        container_port: '',
        protocol: 'tcp',
        host_address: '0.0.0.0',
        host_port: ''
      })
    },
    removePortsItem (index) {
      this.portsData.splice(index, 1)
    },
    resetForm () {
      const node = this.addForm.node
      this.addForm = {
        name: '',
        image: '',
        command: '',
        hostname: '',
        domainname: '',
        entrypoint: '',
        pid_mode: '',
        network_mode: 'bridge',
        privileged: false,
        tty: false,
        auto_remove: false,
        cap_add: [],
        nano_cpus: null,
        mem_limit: null,
        volumes: {},
        environment: [],
        links: {},
        dns: [],
        restart_policy: {
          Name: '',
          MaximumRetryCount: null
        },
        healthcheck: {
          test: '',
          retries: ''
        }
      }
      this.addForm.node = node
      this.kernelPermission = false
      this.volumesData = []
      this.environmentData = []
      this.links = []
      this.dnsData = []
      this.restartPolicyData = {
        restartPolicyName: 'no',
        MaximumRetryCount: null
      }
      this.portsData = []
    },
    validForm () {
      let allValid = true
      this.$refs.addForm.validate((valid) => {
        if (!valid) {
          allValid = false
        }
      })
      this.$refs.restartPolicyForm.validate((valid) => {
        if (!valid) {
          allValid = false
        }
      })
      for (let i in this.$refs.volumesForm) {
        this.$refs.volumesForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      for (let i in this.$refs.envForm) {
        this.$refs.envForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      for (let i in this.$refs.linkForm) {
        this.$refs.linkForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      for (let i in this.$refs.dnsForm) {
        this.$refs.dnsForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      for (let i in this.$refs.portsForm) {
        this.$refs.portsForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      return allValid
    },
    getRunReqData () {
      let reqData = {
        node: this.addForm.node,
        network_mode: this.addForm.network_mode,
        privileged: this.addForm.privileged,
        auto_remove: this.addForm.auto_remove,
        tty: this.addForm.tty
      }
      if (this.addForm.entrypoint) {
        reqData.entrypoint = this.addForm.entrypoint
      }
      if (this.addForm.pid_mode) {
        reqData.pid_mode = this.addForm.pid_mode
      }
      if (this.addForm.name) {
        reqData.name = this.addForm.name
      }
      if (this.addForm.hostname) {
        reqData.hostname = this.addForm.hostname
      }
      if (this.addForm.domainname) {
        reqData.domainname = this.addForm.domainname
      }
      if (this.addForm.healthcheck && this.addForm.healthcheck.test) {
        reqData.healthcheck = this.addForm.healthcheck
        if (!reqData.healthcheck.retries) {
          reqData.healthcheck.retries = 3
        } else {
          reqData.healthcheck.retries = parseInt(reqData.healthcheck.retries)
        }
      }
      if (this.restartPolicyData.restartPolicyName !== 'no') {
        reqData.restart_policy = {
          Name: this.restartPolicyData.restartPolicyName
        }
        if (this.restartPolicyData.restartPolicyName === 'on-failure') {
          reqData.restart_policy.MaximumRetryCount = parseInt(this.restartPolicyData.MaximumRetryCount)
        }
      }
      if (this.kernelPermission) {
        reqData.cap_add = ['ALL']
      }
      if (this.addForm.nano_cpus) {
        reqData.nano_cpus = parseInt(this.addForm.nano_cpus)
      }
      if (this.addForm.mem_limit) {
        reqData.mem_limit = this.addForm.mem_limit + 'm'
      }
      if (this.volumesData.length) {
        reqData.volumes = {}
        for (let i in this.volumesData) {
          const item = this.volumesData[i]
          reqData.volumes[item.hostPath] = {
            bind: item.bind,
            mode: item.mode
          }
        }
      }
      if (this.environmentData.length) {
        reqData.environment = this.environmentData.map(item => `${item.envName}=${item.envValue}`)
      }
      if (this.links.length) {
        reqData.links = {}
        for (let i in this.links) {
          const item = this.links[i]
          reqData.links[item.container] = item.alias ? item.alias : null
        }
      }
      if (this.dnsData.length) {
        reqData.dns = this.dnsData.map(item => item.dnsName)
      }
      if (this.portsData.length) {
        reqData.ports = {}
        for (let i in this.portsData) {
          const item = this.portsData[i]
          reqData.ports[`${item.container_port}/${item.protocol}`] = [item.host_address, item.host_port]
        }
      }
      reqData.image = this.addForm.image
      if (this.addForm.command) {
        reqData.command = this.addForm.command
      }
      return reqData
    },
    submit () {
      const allValid = this.validForm()
      if (allValid) {
        const reqData = this.getRunReqData()
        this.submitting = true
        runContainer(reqData).then(res => {
          this.$Notice.success({
            title: `开始部署「${res.data.Name} 」`,
            desc: `${res.data.Id}`
          })
          this.$router.push({name: 'container'})
          this.submitting = false
        }).catch(res => {
          this.submitting = false
          console.log(res.response)
          if (res.request) {
            this.$Notice.error({
              title: '操作失败！',
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '操作失败！'
            })
          }
        })
      } else {
        this.$Notice.warning({
          title: '表单未填写完整，请检查！'
        })
      }
    },
    ObjectToCmdSubmit () {
      const allValid = this.validForm()
      if (allValid) {
        const reqData = this.getRunReqData()
        this.ObjectToCmdSubmitting = true
        ContainerRunObjectToCmd(reqData).then(res => {
          this.cmd = res.data
          this.cmdModal = true
          this.ObjectToCmdSubmitting = false
          this.$Notice.success({title: '生成成功'})
        }).catch(res => {
          this.ObjectToCmdSubmitting = false
          console.log(res.response)
          if (res.request) {
            this.$Notice.error({
              title: '操作失败！',
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '操作失败！'
            })
          }
        })
      } else {
        this.$Notice.warning({
          title: '表单未填写完整，请检查！'
        })
      }
    },
    CmdToObjectSubmit () {
      if (!this.cmd) {
        this.$Notice.warning({
          title: '命令不能为空！'
        })
        return
      }
      if (!this.addForm.node) {
        this.$Notice.warning({
          title: '请选择节点！'
        })
        return
      }
      this.cmdToObjectSubmitting = true
      ContainerRunCmdToObject(this.cmd, this.addForm.node).then(res => {
        this.resetForm()
        const result = res.data
        if (result.name) {
          this.addForm.name = result.name
        }
        if (result.image) {
          this.addForm.image = result.image
        }
        if (result.command) {
          this.addForm.command = result.command
        }
        if (result.hostname) {
          this.addForm.hostname = result.hostname
        }
        if (result.domainname) {
          this.addForm.domainname = result.domainname
        }
        if (result.restart) {
          this.restartPolicyData.restartPolicyName = result.restart
        }
        if (result.health_cmd) {
          this.addForm.healthcheck.test = result.health_cmd
        }
        if (result.health_retries) {
          this.addForm.healthcheck.retries = result.health_retries
        }
        if (result.network) {
          this.addForm.network_mode = result.network
        } else if (result.net) {
          this.addForm.network_mode = result.net
        }
        if (result.tty) {
          this.addForm.tty = result.tty
        }
        if (result.rm) {
          this.addForm.auto_remove = result.rm
        }
        if (result.entrypoint) {
          this.addForm.entrypoint = result.entrypoint
        }
        if (result.pid_mode) {
          this.addForm.pid_mode = result.pid_mode
        }
        if (result.privileged) {
          this.addForm.privileged = result.privileged
        }
        if (result.cap_add && result.cap_add.indexOf('ALL') > -1) {
          this.kernelPermission = true
        }
        if (result.cpus) {
          this.addForm.nano_cpus = parseInt(result.cpus)
        }
        if (result.memory) {
          this.addForm.mem_limit = Math.round(parseInt(result.memory) / 1024 / 1024)
        }
        if (result.volume) {
          for (let i in result.volume) {
            const volume = result.volume[i].split(':')
            this.volumesData.push({
              hostPath: volume[0],
              bind: volume[1],
              mode: volume.length > 2 ? volume[2] : ''
            })
          }
        }
        if (result.env) {
          for (let i in result.env) {
            const env = result.env[i].split('=')
            this.environmentData.push({
              envName: env[0],
              envValue: env[1]
            })
          }
        }
        if (result.link) {
          for (let i in result.link) {
            const link = result.link[i].split(':')
            this.links.push({
              container: link[0],
              alias: link.length > 1 ? link[1] : null
            })
          }
        }
        if (result.dns) {
          for (let i in result.dns) {
            this.dnsData.push({
              dnsName: result.dns[i]
            })
          }
        }
        if (result.publish) {
          for (let i in result.publish) {
            const port = result.publish[i].split(':')
            let host = port[1].split('/')
            if (port.length > 2) {
              host = port[2].split('/')
            }
            this.portsData.push({
              container_port: host[0],
              protocol: host.length > 1 ? host[1] : 'tcp',
              host_address: port.length > 2 ? port[0] : '0.0.0.0',
              host_port: port.length > 2 ? port[1] : port[0]
            })
          }
        }
        this.cmdToObjectSubmitting = false
        this.$Notice.success({title: '转换成功'})
      }).catch(res => {
        this.cmdToObjectSubmitting = false
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '命令有误！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '命令有误！'
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .env-value .ivu-input-default {
    height: 34px;
  }
</style>
